import { useState } from "react";
import { Repeat } from "lucide-react";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { SubscriptionPlanView } from "@/lib/api/types";
import type { Locale } from "@/lib/i18n/config";
import { Button, useToast } from "@/shared/rd";
import { PanelDrawer } from "@/shared/stores/components/drawer-panel";
import { StoreSubscriptionForm } from "./StoreSubscriptionForm";

type Props = {
  storeId: string;
  plans: SubscriptionPlanView[];
  locale: Locale;
};

/** Change a restaurant's plan: a form, so it opens in a drawer. */
export function StoreSubscriptionModal({
  storeId,
  plans,
  locale,
}: Props) {
  const t = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const toast = useToast();
  const formId = `assign-subscription-${storeId}`;

  return (
    <>
      <Button size="sm" icon={Repeat} onClick={() => setIsOpen(true)}>
        {t(keys.admin.subscriptionChangeAction)}
      </Button>
      <PanelDrawer
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeLabel={t(keys.common.close)}
        badge="register"
        title={t(keys.admin.subscriptionChangeTitle)}
        sub={t(keys.admin.subscriptionChangeHint)}
        width={520}
        actions={
          <Button type="submit" form={formId} variant="primary" size="sm" loading={busy} loadingLabel={t("admin.busyAssigning")}>
            {t(keys.admin.subscriptionAssignAction)}
          </Button>
        }
      >
        <StoreSubscriptionForm
          storeId={storeId}
          plans={plans}
          locale={locale}
          formId={formId}
          hideSubmit
          onBusyChange={setBusy}
          onSuccess={(planName) => {
            setIsOpen(false);
            toast.show({
              message: planName ? t("admin.subscriptionAssignedToast", { plan: planName }) : t(keys.common.updateSuccess),
            });
          }}
        />
      </PanelDrawer>
    </>
  );
}
